<template>
  <div>
    <quick-information-cards :emp-number="empNumber" />
    <oxd-grid class="gsl-hrm-dashboard-grid" :cols="4">
      <oxd-grid-item
        v-if="$can.read('dashboard_time_widget')"
        class="gsl-hrm-dashboard-widget"
      >
        <employee-attendance-widget></employee-attendance-widget>
      </oxd-grid-item>
      <!-- <oxd-grid-item class="gsl-hrm-dashboard-widget">
        <my-action-summary-widget></my-action-summary-widget>
      </oxd-grid-item> -->
      <oxd-grid-item class="gsl-hrm-dashboard-widget">
        <quick-launch-widget></quick-launch-widget>
      </oxd-grid-item>
      <oxd-grid-item
        v-if="$can.read('dashboard_employee_attendance_widget')"
        class="gsl-hrm-dashboard-wide-widget"
      >
        <active-employee-list-widget />
      </oxd-grid-item>
      <oxd-grid-item class="gsl-hrm-dashboard-widget">
        <buzz-latest-post-widget></buzz-latest-post-widget>
      </oxd-grid-item>
      <oxd-grid-item
        v-if="$can.read('dashboard_leave_widget')"
        class="gsl-hrm-dashboard-widget"
      >
        <employees-on-leave-widget></employees-on-leave-widget>
      </oxd-grid-item>
      <oxd-grid-item
        v-if="$can.read('dashboard_subunit_widget')"
        class="gsl-hrm-dashboard-widget"
      >
        <employee-subunit-widget></employee-subunit-widget>
      </oxd-grid-item>

      <oxd-grid-item
        v-if="$can.read('dashboard_location_widget')"
        class="gsl-hrm-dashboard-widget"
      >
        <employee-location-widget></employee-location-widget>
      </oxd-grid-item>

      <!-- <oxd-grid-item
      v-if="$can.read('dashboard_subunit_widget')"
      class="gsl-hrm-dashboard-widget"
    >
      <employee-holiday-list-widget></employee-holiday-list-widget>
    </oxd-grid-item> -->
    </oxd-grid>
  </div>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import QuickLaunchWidget from '@/orangehrmDashboardPlugin/components/QuickLaunchWidget.vue';
import BuzzLatestPostWidget from '@/orangehrmDashboardPlugin/components/BuzzLatestPostWidget.vue';
import EmployeeSubunitWidget from '@/orangehrmDashboardPlugin/components/EmployeeSubunitWidget.vue';
// import MyActionSummaryWidget from '@/orangehrmDashboardPlugin/components/MyActionSummaryWidget.vue';
import EmployeeLocationWidget from '@/orangehrmDashboardPlugin/components/EmployeeLocationWidget.vue';
import EmployeesOnLeaveWidget from '@/orangehrmDashboardPlugin/components/EmployeesOnLeaveWidget.vue';
import EmployeeAttendanceWidget from '@/orangehrmDashboardPlugin/components/EmployeeAttendanceWidget.vue';
import QuickInformationCards from '@/orangehrmDashboardPlugin/components/QuickInformationCards.vue';
import ActiveEmployeeListWidget from '@/orangehrmDashboardPlugin/components/ActiveEmployeeListWidget.vue';
export default {
  components: {
    'quick-launch-widget': QuickLaunchWidget,
    'buzz-latest-post-widget': BuzzLatestPostWidget,
    'employee-subunit-widget': EmployeeSubunitWidget,
    // 'my-action-summary-widget': MyActionSummaryWidget,
    'employee-location-widget': EmployeeLocationWidget,
    'employees-on-leave-widget': EmployeesOnLeaveWidget,
    'employee-attendance-widget': EmployeeAttendanceWidget,
    'quick-information-cards': QuickInformationCards,
    'active-employee-list-widget': ActiveEmployeeListWidget,
  },
  props: {
    empNumber: {
      type: [String, Number],
      required: true,
    },
  },
  mounted() {
    const http = new APIService(window.appGlobal.baseUrl, 'events/push');
    http.create();
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-dashboard-grid {
  margin: 0 auto;
  box-sizing: border-box;
  max-width: calc(430px * 4);
  grid-template-columns: repeat(auto-fill, minmax(max(320px, 100%/4), 1fr));
}
.gsl-hrm-dashboard-wide-widget {
  grid-column: span 1;

  @media (min-width: 1024px) {
    grid-column: span 2;
  }
  @media (min-width: 1262px) {
    grid-column: span 1;
  }
  @media (min-width: 1582px) {
    grid-column: span 2;
  }
}
</style>
